import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import Card from 'components/card';

const ChatRatio = () => {
  const options = {
    chart: {
      type: 'donut',
    },
    labels: ['Liked', 'Disliked'],
    colors: ['#22c55e', '#ef4444'],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '75%',
        },
      },
    },
  };

  const series = [847, 153];

  return (
    <Card extra="p-6">
      <h2 className="text-[24px] font-bold text-[#000] dark:text-white" style={{ fontFamily: "figtree" }}>
          Like / Dislike Ratio
        </h2>
      <div className="flex items-center">
        <div className="w-1/2">
          <ReactApexChart options={options} series={series} type="donut" />
        </div>
        <div className="w-1/2 pl-4">
          <div className="bg-green-100 p-3 rounded-lg mb-2 flex justify-between items-center">
            <div className="flex items-center">
              <FaThumbsUp className="text-green-500 mr-2" />
              <span>Liked</span>
            </div>
            <div className="text-right">
              <span className="font-bold text-green-700">847</span>
              <span className="block text-sm text-gray-500">84.7%</span>
            </div>
          </div>
          <div className="bg-red-100 p-3 rounded-lg flex justify-between items-center">
            <div className="flex items-center">
              <FaThumbsDown className="text-red-500 mr-2" />
              <span>Disliked</span>
            </div>
            <div className="text-right">
              <span className="font-bold text-red-700">153</span>
              <span className="block text-sm text-gray-500">15.3%</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ChatRatio;